export const HTTP_STATUS_CODE = {
	// 4xx: Client Errors
	BAD_REQUEST: 400, // ข้อมูลใน request ผิดพลาด เช่น validation error
	UNAUTHORIZED: 401, // ต้องยืนยันตัวตน (ยังไม่ได้ login หรือ token หมดอายุ หรือ signature ผิด)
	FORBIDDEN: 403, // มีสิทธิ์ไม่เพียงพอ (แม้ login แล้ว)
	NOT_FOUND: 404, // ไม่พบ resource ที่ร้องขอ เช่น URL ผิด
	METHOD_NOT_ALLOWED: 405, // ใช้ HTTP method ไม่ถูกต้อง เช่น POST แทน GET
	CONFLICT: 409, // ข้อมูลขัดแย้ง เช่น user/email ซ้ำ
	UNPROCESSABLE_ENTITY: 422, // ข้อมูลถูกต้องตามรูปแบบ แต่ไม่สามารถประมวลผลได้ เช่น validation ซับซ้อน
	TOO_MANY_REQUESTS: 429, // ส่ง request ถี่เกินไป (rate limit)
	// 5xx: Server Errors
	INTERNAL_SERVER_ERROR: 500, // เซิร์ฟเวอร์เกิดข้อผิดพลาดทั่วไป
	NOT_IMPLEMENTED: 501, // ยังไม่รองรับการทำงานที่ร้องขอ
	BAD_GATEWAY: 502, // ปัญหาที่ proxy หรือ gateway รับ response ผิดพลาด
	SERVICE_UNAVAILABLE: 503, // ระบบยังไม่พร้อมให้บริการ (เช่น maintenance)
	GATEWAY_TIMEOUT: 504, // ไม่ได้รับ response จาก upstream server ทันเวลา
};
